import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { useEffect, useState } from 'react';

export default function ReportAnalysis(props) {
  const [dataList, setDataList] = useState([]);
  const [secDataList, setSecDataList] = useState([]);

  useEffect(() => {
    let captureList = props?.captureList;

    if (captureList === null || captureList === undefined) {
      return;
    }

    const listNames = [
      'cockroachesList',
      'rodentsList',
      'lizardsList',
      'houseFliesList',
      'otherInsectsList',
    ];

    const titles = [
      'COCKROACHES',
      'RODENTS',
      'LIZARDS',
      'HOUSE FLIES',
      'OTHER INSECTS',
    ];

    const result = [];
    const secResult = [];

    for (const key in listNames) {
      const labelList = [];
      const currentDataList = [];

      const currentCaptureList = captureList[listNames[key]];
      const pestsSeq = currentCaptureList[0].pestsSeq;

      for (const capture of currentCaptureList) {

        labelList.push(capture.regDate);
        currentDataList.push(capture.pestsCnt);
      }

      const currentSum = currentDataList.reduce((sum, item) => {
        return sum + parseInt(item)
      }, 0);

      if (currentSum > 0) {
        if (result.length < 3) {
          result.push({
            pestsSeq: pestsSeq,
            labels: labelList,
            datasets: [
              {
                type: 'line',
                label: titles[key],
                borderColor: 'rgb(0, 114, 185)',
                borderWidth: 2,
                data: currentDataList,
                fill: false,
              }
            ]
          });
        } else {
          secResult.push({
            pestsSeq: pestsSeq,
            labels: labelList,
            datasets: [
              {
                type: 'line',
                label: titles[key],
                borderColor: 'rgb(0, 114, 185)',
                borderWidth: 2,
                data: currentDataList,
                fill: false,
              }
            ]
          });
        }
      }
    }

    setDataList(result);
    setSecDataList(secResult);
  }, [props]);

  //  차트 옵션
  const Options = {
    fill: false,
    interaction: {
      intersect: false
    },
    radius: 0,
    relative: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        offset: true,
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 24,
          }
        }
      },
      y: {
        beginAtZero: true,
        min: 0,
        afterDataLimits: (scale) => {
          scale.min = scale.min - 2; // 최소값에서 2를 뺌
        },
        ticks: {
          font: {
            size: 20,
          },
        }
      }
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 20,
            weight: 500,
          },
          usePointStyle: false,
          boxWidth: 0,
        }
      },
      datalabels: {
        align: 'end',
        anchor: 'end',
        font: {
          size: 18,
          weight: 'bold',
        },
        formatter: function (value) {
          // 데이터레이블 값 변경 함수
          return value;
        },
      },
    }
  };

  return (
    <>
      {dataList?.length > 0 &&
        <div className='page'>
          <div className='page-head'>
            <h4>Monthly Report - TREND ANALYSIS</h4>
            <p>UNIVERSAL SOLUTION TECHNOLOGY</p>
          </div>
          <div className='page-content'>
            {dataList?.map((item => {
              return (
                <>
                  <section>
                    <div className='sec-tit'>
                      <i/>
                      <strong>{item.pestsSeq !== '4' ? item.datasets[0].label + ' TREND' : item.datasets[0].label + ' TREND (Moth, Aphids, Etc)'}</strong>
                    </div>
                    <div className='sec-content'>
                      <Line data={item} options={Options} plugins={[ChartDataLabels]}/>
                    </div>
                  </section>
                </>
              )
            }))}
          </div>
        </div>
      }
      {secDataList?.length > 0 &&
        <div className='page'>
          <div className='page-head'>
            <h4>Monthly Report - TREND ANALYSIS</h4>
            <p>UNIVERSAL SOLUTION TECHNOLOGY</p>
          </div>
          <div className='page-content'>
            {secDataList?.map((item => {
              return (
                <>
                  <section>
                    <div className='sec-tit'>
                      <i/>
                      <strong>{item.pestsSeq !== '4' ? item.datasets[0].label + ' TREND' : item.datasets[0].label + ' TREND (Moth, Aphids, Etc)'}</strong>
                    </div>
                    <div className='sec-content'>
                      <Line data={item} options={Options} plugins={[ChartDataLabels]}/>
                    </div>
                  </section>
                </>
              )
            }))}
          </div>
        </div>
      }
    </>
  )
}